import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ShellService } from '@mynexus/mfe-core';
import { ProductNames } from '@mynexus/mynexus-ui-lib';
import { Observable } from 'rxjs';
import { VirtualVisitConfirmation, VirtualVisitReferences, VisitsInformation } from '../model';

@Injectable({
  providedIn: 'root',
})
export class VirtualVisitService {
  readonly apiUrl = inject(ShellService).getBaseUrlFor(ProductNames.CHAPP);
  private readonly httpClient = inject(HttpClient);

  virtualVisitReadiness(referralNumber: string) {
    return this.httpClient.put<void>(`${this.apiUrl}/referrals/${referralNumber}/ready-for-virtual-visit`, {});
  }

  getVirtualVisitReferences(): Observable<VirtualVisitReferences> {
    return this.httpClient.get<VirtualVisitReferences>(`${this.apiUrl}/referrals/virtual-visits/references`);
  }

  confirmVirtualVisit(referralNumber: string, payload: VirtualVisitConfirmation): Observable<void> {
    return this.httpClient.post<void>(`${this.apiUrl}/referrals/${referralNumber}/virtual-visits`, payload);
  }

  getVisitInformation(referralNumber: string): Observable<VisitsInformation> {
    return this.httpClient.get<VisitsInformation>(`${this.apiUrl}/referrals/${referralNumber}/virtual-visits`);
  }

  revertExternalVirtualVisitReadiness(referralNumber: string): Observable<void> {
    return this.httpClient.put<void>(`${this.apiUrl}/referrals/${referralNumber}/External/revert-virtual-visit`, {});
  }

  revertInternalVirtualVisitReadiness(referralNumber: string): Observable<void> {
    return this.httpClient.put<void>(`${this.apiUrl}/referrals/${referralNumber}/Internal/revert-virtual-visit`, {});
  }
}
